export default __webpack_public_path__ + "static/media/discord.f33f7d9f.png";